import { render } from "./MediaAction.vue?vue&type=template&id=be274686"
import script from "./MediaAction.vue?vue&type=script&lang=js"
export * from "./MediaAction.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__